import { createContext, useContext } from 'react'
import { observable, action } from 'mobx'
import axios from 'axios'
import {
    ElementRef,
    LocationType,
    ConfigType,
    DistanceUnitType,
    MapCallbackEventType,
    MapViewClickType,
} from './types/useMapStoreType'
import { Point, Polyline, Multipoint } from '@arcgis/core/geometry'

import Map from '@arcgis/core/Map'
import MapView from '@arcgis/core/views/MapView'

import Graphic from '@arcgis/core/Graphic'
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer'
import TileLayer from '@arcgis/core/layers/TileLayer'
import MapImageLayer from '@arcgis/core/layers/MapImageLayer'
import WMTSLayer from '@arcgis/core/layers/WMTSLayer'
import WMSLayer from '@arcgis/core/layers/WMSLayer'

import esriConfig from '@arcgis/core/config'

import Basemap from '@arcgis/core/Basemap'

import IdentityManager from '@arcgis/core/identity/IdentityManager'
import ServerInfo from '@arcgis/core/identity/ServerInfo'

import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol'
import SpatialReference from '@arcgis/core/geometry/SpatialReference'

import IdentifyParameters from '@arcgis/core/rest/support/IdentifyParameters'
import * as geodesicUtils from '@arcgis/core/geometry/support/geodesicUtils'
import * as projection from '@arcgis/core/geometry/projection'

import * as lang from '@arcgis/core/core/lang'
import { __ } from 'lodash'
import { SignalStateEnum, SignalFeedbackEnum } from '../typings/Enum'

import ConfigAPI from '../constant/ConfigAPI'
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils.js'
import { probabilityRatio } from '../constant/Constant'

import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol.js'
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol.js'
import * as urlUtils from '@arcgis/core/core/urlUtils'

//import VectorTileLayer from 'esri/layers/VectorTileLayer'

const bestStattion1Image = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_best_station_1.png`
const bestStattion2Image = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_best_station_2.png`
const bestStattion3Image = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_best_station_3.png`

const report_pin_green = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/map_pin_green_2.png`
const report_pin_yellow = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/map_pin_yellow_2.png`
const report_pin_red = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/map_pin_red_2.png`
const report_pin_gray = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/map_pin_gray_2.png`

type MapExternalLayer = __esri.MapImageLayer | __esri.WMSLayer | __esri.WMTSLayer | __esri.TileLayer

class MapStore {
    _map = {} as __esri.Map
    _view = {} as __esri.MapView
    _layerStreetBasemap = {} as __esri.TileLayer
    _hybridVectorBasemap = {} as __esri.Basemap
    _layerDTV = {} as __esri.MapImageLayer

    //_graphicPinLayer = {} as __esri.GraphicsLayer
    _graphicStationLayer = {} as __esri.GraphicsLayer
    _graphicSearchStationLayer = {} as __esri.GraphicsLayer
    _graphicReceptorLayer = {} as __esri.GraphicsLayer
    _graphicIdentifyStationLayer = {} as __esri.GraphicsLayer
    _graphicReportDataLayer = {} as __esri.GraphicsLayer
    //_featureLayerPolygon = {} as __esri.FeatureLayer
    _sketchViewModel = {} as __esri.SketchViewModel
    _sketch = {} as __esri.Sketch
    _graphicLine = {} as __esri.Graphic
    _graphicLinePoint1 = {} as __esri.Graphic
    _graphicLinePoint2 = {} as __esri.Graphic
    _graphicBestStation = [] as __esri.Graphic[]
    _graphicStationSelected = {} as __esri.Graphic
    _graphicFlashlight = {} as __esri.Graphic
    _identifyParams = new IdentifyParameters({
        layerIds: [0],
        tolerance: 20,
    })

    _defaultAngle: number = 0

    _stationSymbol = new PictureMarkerSymbol({
        url: `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_station.png`,
        width: 24,
        height: 24,
        yoffset: 12,
    })

    _identifyStationSymbol = new PictureMarkerSymbol({
        url: `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_station.png`,
        // width: 32,
        // height: 38,
        //width: 20,
        width: 48,
        height: 48,
        yoffset: 24,
    })

    _flashlightSymbol = new PictureMarkerSymbol({
        url: `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_flashlight.png`,
        width: 70,
        height: 70,
        angle: this._defaultAngle,
    })

    // _receptorSymbol = {
    //     type: 'simple-marker',
    //     // color: [49, 138, 241], // blue primary
    //     color: [94, 143, 18], // green primary
    //     size: 16,
    //     outline: {
    //         color: [255, 255, 255],
    //         width: 3,
    //     },
    // }

    _receptorSymbol = {
        type: 'simple-marker',
        // color: [49, 138, 241], // blue primary
        color: [94, 143, 18], // green primary
        size: 16,
        outline: {
            color: [255, 255, 255],
            width: 3,
        },
    }

    _receptorLineSymbol = new SimpleLineSymbol({
        type: 'simple-line',
        color: [49, 138, 241], // blue primary
        // color: [94, 143, 18], // green primary
        width: 4,
    })

    _pointDecoratorSymbol = new SimpleMarkerSymbol({
        color: [49, 138, 241], // blue primary
        // color: [94, 143, 18], // green primary
        size: 8,
        outline: {
            color: [255, 255, 255, 0],
        },
    })

    _arrHideStation = [] as __esri.Graphic[]
    _currentIdentifyStation = null as __esri.Graphic | null
    _receptorLocation: LocationType = {
        longitude: 0,
        latitude: 0,
    }
    _mapCallback: MapCallbackEventType = {}
    _handleCurrentViewClick: IHandle | null = null
    _selectedSearchStation: number = 0

    _currentCustomLayerIndex: number = 0

    _regenerateTokenCounter: number = 24
    _tokenExpireInMinutes: number = 60
    _grpFlashlight = null as __esri.Graphic | null
    _currentFlashLightAzimuth = 0

    @observable currentLocation: LocationType | null = null
    @action setCurrentLocation = (param: LocationType) => (this.currentLocation = param)

    @observable identifyResult: StationType | null = null
    @action setIdentifyResult = (param: StationType) => (this.identifyResult = param)

    @observable searchResult: SearchResultType | null = null
    @action setSearchResult = (param: SearchResultType) => (this.searchResult = param)

    @action setVisibleLayer = (layerId: string) => this._setVisibleLayer(layerId)
    @action setVisibleSubLayer = (layerId: string, subLayerId: number) => this._setVisibleSubLayer(layerId, subLayerId)
    @action drawGraphicLine = (point1: LocationType, point2: LocationType) => this._drawGraphicReceptor(point1, point2)

    @action getSearchStationData = async (latitude: number, longitude: number) =>
        await this._callServiceAntennaSearch(latitude, longitude)
    //@action drawGraphicStationSelected = (station: StationType) => this._drawGraphicStationSelected(station)

    @action identifyMapStation = (response: __esri.HitTestResult) => this._identifyMapStation(response)
    @action searchStationByLatLon = async (longitude: number, latitude: number) =>
        await this._searchStationByLatLon(longitude, latitude)

    @action drawSearchStationResult = async (longitude: number, latitude: number, data: SearchResultType) =>
        this._drawSearchStationResult(longitude, latitude, data)

    @action drawReportDataResult = async (reportData: Array<ReportItemDataType>, reportType: string) =>
        this._drawReportDataResult(reportData, reportType)
    @action zoomLocationByLatLon = async (location: LocationType, dataId: number | null, zoomLevel: number) =>
        this._zoomLocation(location, dataId, zoomLevel)
    @action setViewClickEvent = (type: MapViewClickType) => this._setViewClickEvent(type)
    @action clearIdentifyStation = () => this._clearIdentifyStation()
    @action clearReportDataResult = () => this._clearReportDataResult()
    @action calculateDistanceAndAzimuthByTwoPoint = (point1: Point, point2: Point) =>
        this._calculateDistanceAndAzimuthByTwoPoint(point1, point2)

    @action displayHidingSearchStation = () => this._displayHidingSearchStation()
    @action hilightSelectStation = (selectSearchStation: number) => this._hilightSelectStation(selectSearchStation)

    @observable selectStationNumber: number = 0
    @action setStationNumber = (data: number) => (this.selectStationNumber = data)

    @observable resetMapUpperBar: boolean = false
    @action setMapUpperBar = (flag: boolean) => (this.resetMapUpperBar = flag)

    _tempInternalCustomMapLayers: Array<MapCustomLayer> = []
    @observable internalCustomMapLayers: Array<MapCustomLayer> = []
    @observable externalCustomMapLayers: Array<MapCustomLayer> = []

    @action insertCustomMapLayer = (layerUrl: string, layerType: MapCustomLayerType, callback: Function) =>
        this._insertCustomMapLayer(layerUrl, layerType, callback)
    @action removeCustomMapLayer = (customLayerItem: MapCustomLayer) => this._removeCustomMapLayer(customLayerItem)
    @action setVisibleCustomMapLayer = (customLayerItem: MapCustomLayer, visible: boolean) =>
        this._setVisibleCustomMapLayer(customLayerItem, visible)
    @action setVisibleCustomMapSubLayer = (customLayerItem: MapCustomLayer, subLayerId: number, visible: boolean) =>
        this._setVisibleCustomMapSubLayer(customLayerItem, subLayerId, visible)
    @action setOpacityCustomMapLayer = (customLayerItem: MapCustomLayer, opacity: number) =>
        this._setOpacityCustomMapLayer(customLayerItem, opacity)
    @action zoomLayerDefaultExtent = (layerId: string) => this._zoomLayerDefaultExtent(layerId)

    @action clearSearchGraphicAll = () => this._clearSearchGraphicAll()

    @observable useMainStreetMap: boolean = false

    @observable mapRotation: number = 0
    @observable currentZoom: number = 1
    //@observable currentZoom: number = 3
    @action setCurrentZoom = (zoom: number) => (this.currentZoom = zoom)
    @action setMapViewRotation = (rotation: number) => this._setViewRotation(rotation)

    @observable currentProabilityColor: Array<number> = []

    @observable selectedLocation: LocationType | null = null
    @action setSelectedLocation = (param: LocationType) => (this.selectedLocation = param)

    createMap = async (props: ElementRef, mapCallback: MapCallbackEventType) => {
        // const configMapDTT = {
        //     url: `${process.env.REACT_APP_MAP_ARCGIS_SERVER_URL}`,
        //     username: `${process.env.REACT_APP_MAP_DTT_LAYER_USER}`,
        //     password: `${process.env.REACT_APP_MAP_DTT_LAYER_PW}`,
        // }

        this._mapCallback = mapCallback

        //const loadMapDTT = this._registerTokenAsync(configMapDTT)

        urlUtils.addProxyRule({
            urlPrefix: `${process.env.REACT_APP_MAP_DTV_URL}`,
            proxyUrl: `${process.env.REACT_APP_PROXY}`,
        })
        urlUtils.addProxyRule({
            urlPrefix: `${process.env.REACT_APP_MAP_BASEMAP_STREET_URL}`,
            proxyUrl: `${process.env.REACT_APP_PROXY}`,
        })

        // Promise.all([loadMapDTT]).then(async () => {
        //     //Layer Management
        //     this._setTimerRegenerateToken()
        this._layerStreetBasemap = new TileLayer({
            //id: 'basemap-street-layer',
            url: process.env.REACT_APP_MAP_BASEMAP_STREET_URL,
        })

        await this._testStreetMap(this._layerStreetBasemap)

        this._layerDTV = new MapImageLayer({
            url: process.env.REACT_APP_MAP_DTT_IMAGE_LAYER_URL,
            id: 'mapDTT-layer',
            sublayers: [
                {
                    id: 1,
                    visible: false,
                },
                {
                    id: 5,
                    visible: false,
                },
            ],
        })
        this._graphicStationLayer = new GraphicsLayer({
            id: 'station-layer',
        })
        this._graphicSearchStationLayer = new GraphicsLayer({
            id: 'search-station-layer',
        })
        this._graphicReceptorLayer = new GraphicsLayer({
            id: 'search-pin-layer',
        })
        this._graphicIdentifyStationLayer = new GraphicsLayer({
            id: 'identify-station-layer',
        })
        this._graphicReportDataLayer = new GraphicsLayer({
            id: 'report-data-layer',
        })

        this._hybridVectorBasemap = new Basemap({
            portalItem: {
                id: process.env.REACT_APP_HYBRID_VECTOR_PORTAL_ID, // check เพิ่ม
            },
        })

        const basemap = this.useMainStreetMap
            ? { baseLayers: [this._layerStreetBasemap] }
            : ('streets' as any)
        esriConfig.apiKey = process.env.REACT_APP_MAP_APIKEY as string

        this._map = new Map({
            //basemap: 'topo',
            basemap: basemap,
            layers: [
                this._layerDTV,
                this._graphicStationLayer,
                this._graphicReceptorLayer,
                this._graphicSearchStationLayer,
                this._graphicIdentifyStationLayer,
                this._graphicReportDataLayer,
            ],
        })

        if (this.useMainStreetMap) {
            this._layerStreetBasemap.when().catch(() => {
                this.useMainStreetMap = false
                if (this._map.basemap?.baseLayers?.getItemAt(0) === this._layerStreetBasemap) {
                    this._map.basemap = 'streets' as any
                }
            })
        }

        this._view = new MapView({
            map: this._map,
            container: props.elementDiv,
            constraints: {
                minZoom: 6,
                maxZoom: 17, // lock zoom เนื่องจากลูกค้าซื้อถึงแค่ level 17
            },
            center: [100, 13],
            zoom: this.currentZoom,
        })

        this._view.ui.remove('zoom')

        this._addPositionComponent(this._view, props)
        this.mapRotation = this._view.rotation

        this._setupMapViewEventListener(this._view, 'mouse-wheel')
        this._setupMapViewEventListener(this._view, 'drag')
        this._view.when(() => {
            this._queryInternalCustomMap()
            this._queryFeatureAndAddGraphicPoint()
            this._mapCallback.onViewLoaded?.()
        })

        this._setViewClickEvent(MapViewClickType.Identify)

        reactiveUtils.when(
            () => this._view.stationary === true,
            () => {
                this.setCurrentZoom(this._view.zoom)
            },
        )
        // })
    }

    _testStreetMap = (layer: __esri.TileLayer) => {
        let promise = new Promise((resolve) => {
            layer
                .load()
                .then(() => {
                    this.useMainStreetMap = true
                    resolve(true)
                })
                .catch(() => {
                    this.useMainStreetMap = false
                    this.currentZoom = 6
                    resolve(false)
                })
        })

        return promise
    }

    _testHitGraphic = (event: __esri.ViewClickEvent) => {
        this._view.hitTest(event).then(async (response: __esri.HitTestResult) => {
            this._mapCallback.onViewClickIdentify?.(response)
        })
    }

    _queryFeatureAndAddGraphicPoint = async () => {
        try {
            const url = `${process.env.REACT_APP_API}/api/antenna/points`
            const result = await axios.get(url, ConfigAPI)

            if (result?.data) {
                result?.data.forEach((item: StationMapInfoType) => {
                    const graphic = new Graphic({
                        geometry: new Point({
                            longitude: item.longitude as number,
                            latitude: item.latitude as number,
                        }),
                        symbol: this._stationSymbol,
                        attributes: {
                            STATION_ID: item.station_id,
                        },
                    })
                    this._graphicStationLayer.add(graphic)
                })
            }
            this._mapCallback.onStationLoaded?.()
        } catch (ex) {
            console.log('error ::', ex)
            this._mapCallback.onStationLoaded?.()
        }
    }

    _queryInternalCustomMap = async () => {
        const url = `${process.env.REACT_APP_API}/api/maps/default`
        try {
            const result = await axios.get<any>(url, ConfigAPI)
            let listNewLayer: Array<MapExternalLayer> = []
            let listPromise: Array<Promise<MapCustomLayer | null>> = []

            if (result?.data) {
                let data = result.data as InternalMapResult

                // data.maps = data.maps.filter((item)=> item.mapId !== 'MAP-DEFAULT-003')
                // console.log('data',data);

                data.maps.forEach((item, index) => {
                    switch (item.mapType) {
                        case 'tile': {
                            const tiledLayer = new TileLayer({
                                id: item.mapId,
                                url: item.url,
                                title: item.mapName,
                                visible: false,
                            })
                            listNewLayer.push(tiledLayer)
                            listPromise.push(this._prepareAddInternalCustomLayer(tiledLayer, item.mapType, index))
                            break
                        }
                        case 'dynamic': {
                            const dynamicLayer = new MapImageLayer({
                                id: item.mapId,
                                url: item.url,
                                title: item.mapName,
                                visible: false,
                            })
                            listNewLayer.push(dynamicLayer)
                            listPromise.push(this._prepareAddInternalCustomLayer(dynamicLayer, item.mapType, index))
                            break
                        }
                        case 'wms': {
                            const wmsLayer = new WMSLayer({
                                id: item.mapId,
                                url: item.url,
                                title: item.mapName,
                                visible: false,
                            })
                            listNewLayer.push(wmsLayer)
                            listPromise.push(this._prepareAddInternalCustomLayer(wmsLayer, item.mapType, index))
                            break
                        }
                        case 'wmts': {
                            const wmtsLayer = new WMTSLayer({
                                id: item.mapId,
                                url: item.url,
                                title: item.mapName,
                                visible: false,
                            })

                            listNewLayer.push(wmtsLayer)
                            listPromise.push(this._prepareAddInternalCustomLayer(wmtsLayer, item.mapType, index))
                            break
                        }
                        default:
                            break
                    }
                })

                this._map.addMany(listNewLayer, 0)
                Promise.all(listPromise).then((values) => {
                    this.internalCustomMapLayers = values.filter((item) => item !== null) as MapCustomLayer[]
                    this._mapCallback.onSystemMapLoaded?.()
                })
            } else {
                this._mapCallback.onSystemMapLoaded?.()
            }
        } catch (ex) {
            console.log('error ::', ex)
            this._mapCallback.onSystemMapLoaded?.()
        }
    }

    _prepareAddInternalCustomLayer = async (newLayer: MapExternalLayer, mapType: MapCustomLayerType, index: number) => {
        let promise = new Promise<MapCustomLayer | null>((resolve) => {
            newLayer.on('layerview-create', () => {
                let newCustomItem = this._createCustomMapItem(newLayer, mapType, index)
                this._tempInternalCustomMapLayers.push(newCustomItem)
                resolve(newCustomItem)
            })

            newLayer.on('layerview-create-error', (err) => {
                resolve(null)
            })
        })

        return promise
    }

    _setupMapViewEventListener = (view: MapView, name: string, divMapElement?: HTMLDivElement) => {
        // view.on(name, (value: any) => {
        //     const point = view.toMap({ x: value.x, y: value.y })
        //     switch (name) {
        //         case 'pointer-move':
        //             // this.setLocationPointer(point)

        //             //If use cursor pointer effect
        //             if (divMapElement) {
        //                 this._setupMapCursorHoverOnGraphic(divMapElement)
        //             }
        //             break

        //         case 'mouse-wheel':
        //             // this.getExtentMapView()
        //             break
        //         case 'drag':
        //             if (this.mapRotation != this._view.rotation) {
        //                 this.mapRotation = this._view.rotation
        //                 this._reCalculateFlashlightAngle()
        //             }
        //             break
        //         default:
        //             break
        //     }
        // })

        switch (name) {
            case 'pointer-move':
                view.on(name, (value: any) => {
                    const point = view.toMap({ x: value.x, y: value.y })
                    if (divMapElement) {
                        this._setupMapCursorHoverOnGraphic(divMapElement)
                    }
                    // this.setLocationPointer(point)
                })

                //If use cursor pointer effect
                break

            case 'mouse-wheel':
                view.on(name, (value: any) => {
                    const point = view.toMap({ x: value.x, y: value.y })

                    // this.getExtentMapView()
                })
                break
            case 'drag':
                view.on(name, (value: any) => {
                    const point = view.toMap({ x: value.x, y: value.y })
                    if (this.mapRotation != this._view.rotation) {
                        this.mapRotation = this._view.rotation
                        this._reCalculateFlashlightAngle()
                    }
                })

                break
            default:
                break
        }
    }

    //Use this will result in performance drop?
    _setupMapCursorHoverOnGraphic = (divMapElement: HTMLDivElement) => {
        this._view.on('pointer-move', (evt) => {
            this._view.hitTest(evt).then((r) => {
                if (r.results[0].type === 'graphic' && r.results.length > 0 && r.results[0]?.graphic) {
                    const layerId = r.results[0]?.graphic.layer?.id
                    if (
                        layerId === 'search-station-layer' ||
                        layerId === 'station-layer' ||
                        layerId === 'report-data-layer'
                    ) {
                        divMapElement.style.cursor = 'pointer'
                    } else {
                        divMapElement.style.cursor = 'default'
                    }
                } else {
                    divMapElement.style.cursor = 'default'
                }
            })
        })
    }

    _setViewClickEvent = (type: MapViewClickType) => {
        if (this._handleCurrentViewClick) {
            this._handleCurrentViewClick.remove()
        }

        // switch (type) {
        //     case MapViewClickType.SearchStation:
        //         this._handleCurrentViewClick = this._view.on('click', (event: __esri.ViewClickEvent) => {
        //             this._mapCallback.onViewClickSearch?.(event.mapPoint)
        //         })
        //         break
        //     // case MapViewClickType.Identify:
        //     //     this._handleCurrentViewClick = this._view.on('click', (event: __esri.ViewClickEvent) => {
        //     //         this._testHitGraphic(event)
        //     //     })
        //     //     break
        //     default:
        //         this._handleCurrentViewClick = this._view.on('click', (event: __esri.ViewClickEvent) => {
        //             this._testHitGraphic(event)
        //         })
        //         break
        // }

        if (type === MapViewClickType.SearchStation) {
            this._handleCurrentViewClick = this._view.on('click', (event: __esri.ViewClickEvent) => {
                this._mapCallback.onViewClickSearch?.(event.mapPoint)
            })
        } else {
            this._handleCurrentViewClick = this._view.on('click', (event: __esri.ViewClickEvent) => {
                this._testHitGraphic(event)
            })
        }
    }

    _identifyMapStation = async (response: __esri.HitTestResult) => {
        let result: IdentifyDataResult = {
            layerId: '',
            data: null,
        }

        if (response.results.length > 0 && response.results[0].type === 'graphic') {
            // console.log('response.results[0].graphic',response.results[0].graphic);
            let data: StationType | ReportItemDataType | string | null = null
            const layerId = response.results[0].graphic.layer?.id
            let stationId: number = 0

            if (layerId !== 'report-data-layer') {
                stationId = response.results[0].graphic.attributes?.STATION_ID ?? 0
            }
            //response.results[0].graphic.attributes.STATION_ID

            switch (layerId) {
                case 'search-station-layer': {
                    const selectSearchStation = response.results[0].graphic.attributes.RESULT_NUMBER

                    if (this._selectedSearchStation === selectSearchStation) {
                        const { result } = await this.callServiceAntennaIdentify(stationId)
                        data = result?.data as StationType
                        data.displayAzimuthAndDistance = true
                        this._clearIdentifyStation()
                    } else {
                        this._hilightSelectStation(selectSearchStation)
                        this._mapCallback.onSelectStationChange?.(selectSearchStation)
                    }
                    break
                }
                case 'station-layer': {
                    const { result } = await this.callServiceAntennaIdentify(stationId)
                    //console.log('response.results[0].graphic',response.results[0].graphic);
                    this._drawIdentifyStationGraphic(response.results[0].graphic)
                    response.results[0].graphic.visible = false
                    const { longitude, latitude } = response.results[0].graphic.geometry as __esri.Point
                    this._view.goTo({
                        center: [longitude, latitude],
                    })
                    //console.log('result', result);
                    data = result?.data as StationType
                    data.displayAzimuthAndDistance = false
                    break
                }
                case 'identify-station-layer':
                    data = 'donothing'
                    break
                case 'report-data-layer':
                    //console.log('response.results[0].graphic.attributes',response.results[0].graphic.attributes)
                    data = response.results[0].graphic.attributes
                    break
                default:
                    break
            }

            if (layerId) {
                result.layerId = layerId.toString()
                result.data = data
            }
        }

        return result
    }

    _drawIdentifyStationGraphic = (identifyStation: __esri.Graphic) => {
        this._clearIdentifyStation()
        this._currentIdentifyStation = identifyStation

        let graphic = new Graphic({
            geometry: this._currentIdentifyStation.geometry,
            symbol: this._identifyStationSymbol,
            attributes: {
                STATION_ID: identifyStation.attributes.STATION_ID,
            },
        })

        this._graphicIdentifyStationLayer.add(graphic)
    }

    _clearIdentifyStation = () => {
        if (this._currentIdentifyStation) {
            this._currentIdentifyStation.visible = true
            this._graphicIdentifyStationLayer.removeAll()
        }
    }

    _clearSearchGraphicAll = () => {
        this._graphicReceptorLayer.removeAll()
        this._graphicSearchStationLayer.removeAll()
        this._grpFlashlight = null
    }

    _clearReportDataResult = () => {
        this._graphicReportDataLayer.removeAll()
    }

    _searchStationByLatLon = async (longitude: number, latitude: number) => {
        const { result: resultSearch } = await this._callServiceAntennaSearch(latitude, longitude)
        if (resultSearch?.data) {
            await this._drawSearchStationResult(longitude, latitude, resultSearch?.data as SearchResultType)
        }
        //await this._callServiceSearchAndDrawGraphicBestStation(longitude, latitude)
    }

    _drawSearchStationResult = async (longitude: number, latitude: number, data: SearchResultType) => {
        if (this._graphicSearchStationLayer) {
            if (this._graphicSearchStationLayer?.graphics && this._graphicSearchStationLayer?.graphics.length > 0) {
                this._graphicSearchStationLayer.removeAll()
            }
        }

        this._clearIdentifyStation()

        let locationList: LocationType[] = []

        this._receptorLocation = {
            longitude: longitude,
            latitude: latitude,
        }

        locationList.push({
            longitude: longitude,
            latitude: latitude,
        })

        const stationLocation: LocationType = {
            longitude: data.best_server?.longitude || 0,
            latitude: data.best_server?.latitude || 0,
        }

        // this._drawGraphicReceptor(this._receptorLocation, stationLocation)

        const { best_server, second_server, third_server } = data
        const current_location_point = new Point({
            latitude: this._receptorLocation.latitude,
            longitude: this._receptorLocation.longitude,
        })
        if (best_server) {
            const best_server_point = new Point({
                latitude: best_server.latitude,
                longitude: best_server.longitude,
            })

            locationList.push({
                longitude: best_server.longitude as number,
                latitude: best_server.latitude as number,
            })

            const { distance, azimuth } = this._calculateDistanceAndAzimuthByTwoPoint(
                current_location_point,
                best_server_point,
            )
            best_server.distance = distance
            best_server.azimuth = azimuth
        }
        if (second_server) {
            const second_server_point = new Point({
                latitude: second_server.latitude,
                longitude: second_server.longitude,
            })

            locationList.push({
                longitude: second_server.longitude as number,
                latitude: second_server.latitude as number,
            })

            const { distance, azimuth } = this._calculateDistanceAndAzimuthByTwoPoint(
                current_location_point,
                second_server_point,
            )
            second_server.distance = distance
            second_server.azimuth = azimuth
        }
        if (third_server) {
            const third_server_point = new Point({
                latitude: third_server.latitude,
                longitude: third_server.longitude,
            })

            locationList.push({
                longitude: third_server.longitude as number,
                latitude: third_server.latitude as number,
            })

            const { distance, azimuth } = this._calculateDistanceAndAzimuthByTwoPoint(
                current_location_point,
                third_server_point,
            )
            third_server.distance = distance
            third_server.azimuth = azimuth
        }
        this.searchResult = data
        this._hideSearchStation()

        const probability = data.probability || 0.7
        if (probability >= probabilityRatio.good) {
            this.currentProabilityColor = [0, 176, 80]
        } else if (probability >= probabilityRatio.average) {
            this.currentProabilityColor = [244, 170, 62]
        } else {
            this.currentProabilityColor = [207, 49, 49]
        }

        this._drawGraphicSelectedStation(1)
        this._drawGraphicReceptor(this._receptorLocation, stationLocation)
        this._zoomSelection(this._view, locationList)
    }

    callServiceAntennaIdentify = async (stationId: number) => {
        try {
            const url = `${process.env.REACT_APP_API}/api/antenna/${stationId}`
            const result = await axios.get(url, ConfigAPI)
            return { result }
        } catch (error) {
            return { error }
        }
    }

    _callServiceAntennaSearch = async (latitude: number, longitude: number) => {
        try {
            // const url = `${process.env.REACT_APP_API}/api/antenna/search/coordinate`
            // const result = await axios.get(url, { params: { longitude, latitude } })
            const url = `${process.env.REACT_APP_API}/api/antenna/search/coordinate?latitude=${latitude}&longitude=${longitude}`
            const result = await axios.get(url, ConfigAPI)
            return { result }
        } catch (error) {
            return { error }
        }
    }

    _addPositionComponent = (view: __esri.MapView, props: ElementRef) => {
        view.ui.padding = { top: 16, left: 16, right: 16, bottom: 30 }
        props.componentTopLeft?.setAttribute('class', 'esri-component')
        props.componentTopLeft?.setAttribute('style', 'width: -webkit-fill-available;')

        switch (view.widthBreakpoint) {
            case 'xsmall':
            // view.ui.add([props.componentTopLeft, props.componentTopRight], 'top-right')
            // props.componentTopLeft?.setAttribute('class', 'esri-component')
            // props.componentTopLeft?.setAttribute(
            //     'style',
            //     'width: -webkit-fill-available; width: -moz-available; margin-top: 0px;',
            // )

            // view.ui.add([props.componentBottomScreenWeb], 'manual')
            // props.componentBottomScreenWeb?.setAttribute('class', 'esri-component')
            // props.componentBottomScreenWeb?.setAttribute('style', 'display: none;')

            // view.ui.add([props.componentBottomScreenMobile], 'manual')
            // props.componentBottomScreenMobile?.setAttribute('class', 'esri-component')
            // props.componentBottomScreenMobile?.setAttribute(
            //     'style',
            //     'bottom: 22px; width: -webkit-fill-available; width: -moz-available;',
            // )
            // break
            case 'small':
                view.ui.add([props.componentTopLeft, props.componentTopRight], 'top-right')
                props.componentTopLeft?.setAttribute('class', 'esri-component')
                props.componentTopLeft?.setAttribute(
                    'style',
                    'width: -webkit-fill-available; width: -moz-available; margin-top: 0px;',
                )

                view.ui.add([props.componentBottomScreenWeb], 'manual')
                props.componentBottomScreenWeb?.setAttribute('class', 'esri-component')
                props.componentBottomScreenWeb?.setAttribute('style', 'display: none;')

                view.ui.add([props.componentBottomScreenMobile], 'manual')
                props.componentBottomScreenMobile?.setAttribute('class', 'esri-component')
                props.componentBottomScreenMobile?.setAttribute(
                    'style',
                    'bottom: 22px; width: -webkit-fill-available; width: -moz-available;',
                )
                break
            case 'medium':
            case 'large':
            case 'xlarge':
                view.ui.add([props.componentTopLeft], 'top-left')
                props.componentTopLeft?.setAttribute('class', 'esri-component')
                props.componentTopLeft?.setAttribute(
                    'style',
                    'width: -webkit-fill-available; width: -moz-available; margin-top: 50px;',
                )

                view.ui.add([props.componentTopRight], 'top-right')
                props.componentTopRight?.setAttribute('class', 'esri-component')
                props.componentTopRight?.setAttribute(
                    'style',
                    'box-shadow: none; margin-bottom: 0px; align-items: center; margin-top: 50px;',
                )

                view.ui.add([props.componentBottomScreenWeb], 'manual')
                props.componentBottomScreenWeb?.setAttribute('class', 'esri-component')
                props.componentBottomScreenWeb?.setAttribute(
                    'style',
                    'bottom: 20px; width: -webkit-fill-available; width: -moz-available;',
                )

                view.ui.add([props.componentBottomScreenMobile], 'manual')
                props.componentBottomScreenMobile?.setAttribute('class', 'esri-component')
                props.componentBottomScreenMobile?.setAttribute('style', 'display: none;')
                break
            default:
        }

        view.watch('widthBreakpoint', function (breakpoint) {
            switch (breakpoint) {
                case 'xsmall':
                    view.ui.add([props.componentBottomScreenWeb], 'manual')
                    props.componentBottomScreenWeb?.setAttribute('class', 'esri-component')
                    props.componentBottomScreenWeb?.setAttribute('style', 'display: none;')

                    view.ui.add([props.componentBottomScreenMobile], 'manual')
                    props.componentBottomScreenMobile?.setAttribute('class', 'esri-component')
                    props.componentBottomScreenMobile?.setAttribute(
                        'style',
                        'bottom: 22px; width: -webkit-fill-available; width: -moz-available;',
                    )
                    break
                case 'small':
                    view.ui.add([props.componentTopLeft, props.componentTopRight], 'top-right')
                    props.componentTopRight?.setAttribute('class', 'esri-component')
                    props.componentTopRight?.setAttribute(
                        'style',
                        'box-shadow: none; margin-bottom: 0px; align-items: center; margin-top: 0px;',
                    )
                    props.componentTopLeft?.setAttribute('class', 'esri-component')
                    props.componentTopLeft?.setAttribute(
                        'style',
                        'width: -webkit-fill-available; width: -moz-available; margin-top: 0px;',
                    )

                    view.ui.add([props.componentBottomScreenWeb], 'manual')
                    props.componentBottomScreenWeb?.setAttribute('class', 'esri-component')
                    props.componentBottomScreenWeb?.setAttribute('style', 'display: none;')

                    view.ui.add([props.componentBottomScreenMobile], 'manual')
                    props.componentBottomScreenMobile?.setAttribute('class', 'esri-component')
                    props.componentBottomScreenMobile?.setAttribute(
                        'style',
                        'bottom: 22px; width: -webkit-fill-available; width: -moz-available;',
                    )
                    break
                case 'medium':
                case 'large':
                case 'xlarge':
                    view.ui.add([props.componentTopLeft], 'top-left')
                    props.componentTopLeft?.setAttribute('class', 'esri-component')
                    props.componentTopLeft?.setAttribute(
                        'style',
                        'width: -webkit-fill-available; width: -moz-available; margin-top: 50px;',
                    )

                    view.ui.add([props.componentTopRight], 'top-right')
                    props.componentTopRight?.setAttribute('class', 'esri-component')
                    props.componentTopRight?.setAttribute(
                        'style',
                        'box-shadow: none; margin-bottom: 0px; align-items: center; margin-top: 50px;',
                    )

                    view.ui.add([props.componentBottomScreenWeb], 'manual')
                    props.componentBottomScreenWeb?.setAttribute('class', 'esri-component')
                    props.componentBottomScreenWeb?.setAttribute(
                        'style',
                        'bottom: 20px; width: -webkit-fill-available; width: -moz-available;',
                    )

                    view.ui.add([props.componentBottomScreenMobile], 'manual')
                    props.componentBottomScreenMobile?.setAttribute('class', 'esri-component')
                    props.componentBottomScreenMobile?.setAttribute('style', 'display: none;')
                    break
                default:
            }
        })
    }

    _setTimerRegenerateToken = () => {
        if (this._regenerateTokenCounter) {
            const configMapOra = {
                url: `${process.env.REACT_APP_MAP_ARCGIS_SERVER_URL}`,
                username: `${process.env.REACT_APP_MAP_DTT_LAYER_USER}`,
                password: `${process.env.REACT_APP_MAP_DTT_LAYER_PW}`,
            }

            setTimeout(
                () => {
                    this._registerTokenAsync(configMapOra).then(() => {
                        this._regenerateTokenCounter--
                        console.log('_regenerateTokenCounter', this._regenerateTokenCounter)
                        this._setTimerRegenerateToken()
                    })
                },
                1000 * 60 * this._tokenExpireInMinutes,
            )
        }
    }

    _registerTokenAsync = (config: ConfigType) => {
        const { url, username, password } = config

        //console.log('url',url);

        const promiseRegisToken = new Promise((resolve, reject) => {
            const serverInfo = new ServerInfo({
                tokenServiceUrl: url + '/tokens/generateToken',
                hasServer: true,
                shortLivedTokenValidity: this._tokenExpireInMinutes,
                //shortLivedTokenValidity: 60*24
            })
            IdentityManager.generateToken(serverInfo, {
                username: username,
                password: password,
            }).then((res) => {
                IdentityManager.registerToken({
                    server: url + '/rest/services',
                    token: res.token,
                    expires: res.expires,
                })
                resolve(null)
            })
        })
        return promiseRegisToken
    }

    _drawSearchStationResultPin = (point: Point, symbolUrl: string, data: any, isSelected: boolean) => {
        let symbol = new PictureMarkerSymbol({
            url: symbolUrl,
            width: 36,
            height: 36,
            yoffset: 24,
        })
        if (isSelected) {
            symbol.width = 48
            symbol.height = 48
            symbol.yoffset = 24
        }

        const graphic = new Graphic({
            geometry: point,
            symbol: symbol,
            attributes: data,
        })

        this._graphicSearchStationLayer.add(graphic)
        return graphic
    }

    _hilightSelectStation = (selectSearchStation: number) => {
        if (this._graphicSearchStationLayer.graphics.length > 0) {
            const findGraphic = this._graphicSearchStationLayer.graphics.find((grp) => {
                return grp.attributes.RESULT_NUMBER === selectSearchStation
            })

            const { longitude, latitude } = findGraphic?.geometry as Point
            // const stationLocation: LocationType = {
            //     latitude,
            //     longitude,
            // }

            //console.log(findGraphic.attributes)

            this._drawGraphicSelectedStation(selectSearchStation)
            //this._drawGraphicReceptor(this._receptorLocation, stationLocation)
            this.setStationNumber(selectSearchStation)

            if (latitude && longitude) {
                const stationLocation: LocationType = {
                    latitude,
                    longitude,
                }

                this._drawGraphicReceptor(this._receptorLocation, stationLocation)
            }
        }
    }

    _hideSearchStation = () => {
        if (this.searchResult) {
            const stations = this.searchResult

            this._displayHidingSearchStation()
            let hideStationIdList: number[] = []

            if (stations.best_server) {
                hideStationIdList.push(stations.best_server.station_id as number)
            }
            if (stations.second_server) {
                hideStationIdList.push(stations.second_server.station_id as number)
            }
            if (stations.third_server) {
                hideStationIdList.push(stations.third_server.station_id as number)
            }

            this._arrHideStation = []
            this._graphicStationLayer?.graphics?.forEach((grp: __esri.Graphic) => {
                if (hideStationIdList.indexOf(grp.attributes.STATION_ID) !== -1) {
                    this._arrHideStation.push(grp)
                }
            })

            this._arrHideStation.forEach((grp) => {
                grp.visible = false
            })
        }
    }

    _displayHidingSearchStation = () => {
        this._arrHideStation.forEach((grp) => {
            grp.visible = true
        })
    }

    _drawGraphicSelectedStation = (selectedStation: number) => {
        if (this.searchResult) {
            if (this._graphicSearchStationLayer) {
                this._graphicSearchStationLayer?.removeAll()
            }

            const stations = this.searchResult
            this._selectedSearchStation = selectedStation

            if (stations.best_server) {
                const point = new Point({
                    latitude: stations.best_server.latitude,
                    longitude: stations.best_server.longitude,
                })
                const graphic = this._drawSearchStationResultPin(
                    point,
                    bestStattion1Image,
                    {
                        STATION_ID: stations.best_server.station_id,
                        RESULT_NUMBER: 1,
                    },
                    selectedStation === 1,
                )
            }
            if (stations.second_server) {
                const point = new Point({
                    latitude: stations.second_server.latitude,
                    longitude: stations.second_server.longitude,
                })
                const graphic = this._drawSearchStationResultPin(
                    point,
                    bestStattion2Image,
                    //this._bestStation2Symbol,
                    {
                        STATION_ID: stations.second_server.station_id,
                        RESULT_NUMBER: 2,
                    },
                    selectedStation === 2,
                )
                //this._graphicBestStation.push(graphic)
            }
            if (stations.third_server) {
                const point = new Point({
                    latitude: stations.third_server.latitude,
                    longitude: stations.third_server.longitude,
                })
                const graphic = this._drawSearchStationResultPin(
                    point,
                    bestStattion3Image,
                    //this._bestStation3Symbol,
                    {
                        STATION_ID: stations.third_server.station_id,
                        RESULT_NUMBER: 3,
                    },
                    selectedStation === 3,
                )
                //this._graphicBestStation.push(graphic)
            }
        }
    }

    _drawGraphicReceptor = (point1: LocationType, point2: LocationType) => {
        this._graphicReceptorLayer.removeAll()

        let receptorLineSymbol = lang.clone(this._receptorLineSymbol)
        let receptorSymbol = lang.clone(this._receptorSymbol)
        //receptorLineSymbol.color = this.currentProabilityColor
        receptorSymbol.color = this.currentProabilityColor
        //let recepterLineSymbol = {...this._receptorLineSymbol}
        //recepterLineSymbol.color

        let graphicLine = new Graphic({
            geometry: new Polyline({
                paths: [
                    [
                        [point1.longitude, point1.latitude],
                        [point2.longitude, point2.latitude],
                    ],
                ],
            }),
            symbol: receptorLineSymbol,
        })

        const p1 = new Point({
            latitude: point1.latitude,
            longitude: point1.longitude,
        })
        const p2 = new Point({
            latitude: point2.latitude,
            longitude: point2.longitude,
        })

        const grpPointDecorator1 = new Graphic({
            geometry: p1,
            symbol: this._pointDecoratorSymbol,
        })
        const grpPointDecorator2 = new Graphic({
            geometry: p2,
            symbol: this._pointDecoratorSymbol,
        })
        const grpReceptor = new Graphic({
            geometry: p1,
            symbol: receptorSymbol,
        })

        const { azimuth } = this._calculateDistanceAndAzimuthByTwoPoint(p1, p2)

        this._currentFlashLightAzimuth = azimuth || 0 + this._defaultAngle
        this._flashlightSymbol.angle = this._currentFlashLightAzimuth
        // console.log('this.mapRotation',this.mapRotation);
        // console.log('flashlightSymbol.angle ',azimuth || 0 + this._defaultAngle);

        this._grpFlashlight = new Graphic({
            geometry: p1,
            symbol: this._flashlightSymbol,
        })

        this._graphicReceptorLayer.addMany([
            graphicLine,
            grpPointDecorator1,
            grpPointDecorator2,
            this._grpFlashlight,
            grpReceptor,
        ])
        this._reCalculateFlashlightAngle()
    }

    _setVisibleLayer = (layerId: string) => {
        // if (this._map.findLayerById(layerId) != null) {
        //     this._map.findLayerById(layerId).visible = !this._map.findLayerById(layerId)?.visible
        // }

        const map = this._map.findLayerById(layerId)
        if (map) {
            map.visible = !this._map.findLayerById(layerId)?.visible
        }
    }

    _setVisibleSubLayer = (layerId: string, subLayerId: number) => {
        const subLayer = this._layerDTV?.sublayers?.find((item) => {
            return item.id === subLayerId
        })
        if (subLayer) {
            subLayer.visible = !subLayer.visible
        }
    }

    _calculateDistanceAndAzimuthByTwoPoint = (point1: Point, point2: Point, unit: DistanceUnitType = 'meters') => {
        let { distance, azimuth, reverseAzimuth } = geodesicUtils.geodesicDistance(point1, point2, unit)

        let new_distance = ''

        if (azimuth) {
            azimuth = this._calculateAzimuthFromNorth(azimuth)
        }
        if (distance) {
            new_distance = this._calculateDistance(distance)
        } else {
            new_distance = this._calculateDistance(0)
        }

        return { distance: new_distance, azimuth: Math.floor(azimuth as number) }
    }

    _calculateAzimuthFromNorth = (azimuth: number) => {
        return azimuth === -0 ? 0 : azimuth < 0 ? 360 + azimuth : azimuth
    }

    _calculateDistance = (distance: number) => {
        let redistance: number = distance
        if (distance >= 1000) {
            redistance =
                Math.ceil((Math.ceil((distance / 1000 + Number.EPSILON) * 100) / 100 + Number.EPSILON) * 10) / 10
        }

        return distance >= 1000 ? `${redistance} km` : `${redistance.toFixed(0)} m`
        //return distance >= 1000 ? `${(distance / 1000).toFixed(1)} km` : `${distance.toFixed(0)} m`
    }

    _zoomSelection = (view: MapView, locationList: LocationType[]) => {
        //console.log('locationList',locationList);
        let multiPoint = new Multipoint()
        locationList.forEach((location) => {
            multiPoint.addPoint(
                new Point({
                    longitude: location.longitude,
                    latitude: location.latitude,
                }),
            )
        })

        if (multiPoint.extent) {
            view.goTo(multiPoint.extent.expand(1.5))
        }
    }

    _zoomLocation = (location: LocationType, dataId: number | null, zoomLevel: number = 10) => {
        // ให้ location ที่เลือกอยู่บนสุด
        const tempGraphic: any[] = [...(this._graphicReportDataLayer.graphics as any).items]
        if (tempGraphic) {
            this._graphicReportDataLayer.removeAll()
            const targetGraphic = tempGraphic.find(
                (item: any) =>
                    item.geometry.latitude === location.latitude &&
                    item.geometry.longitude === location.longitude &&
                    item.attributes.dataId == dataId,
            )
            const sortGraphic = [...tempGraphic.filter((item: any) => item !== targetGraphic), targetGraphic]
            this._graphicReportDataLayer.addMany(sortGraphic)
        }

        this._view.goTo({
            center: [location.longitude, location.latitude],
            zoom: zoomLevel,
        })
    }

    _drawReportDataResult = (reportData: Array<ReportItemDataType>, reportType: string) => {
        this._graphicReportDataLayer.removeAll()

        if (reportData.length > 0) {
            let multiPoint = new Multipoint()
            reportData.forEach((item) => {
                if (item.location) {
                    if (item.location.latitude !== 0 && item.location.longitude !== 0) {
                        let itemPoint = new Point({
                            longitude: item.location.longitude,
                            latitude: item.location.latitude,
                        })

                        multiPoint.addPoint(itemPoint)
                        let symbolUrl = report_pin_gray
                        if (reportType === 'survey') {
                            if (item.signalState) {
                                switch (item.signalState.code) {
                                    case SignalStateEnum.Normal:
                                        symbolUrl = report_pin_green
                                        break
                                    case SignalStateEnum.Abnormal:
                                        symbolUrl = report_pin_red
                                        break
                                    case SignalStateEnum.None:
                                    default:
                                        symbolUrl = report_pin_gray
                                        break
                                }
                            }
                        } else if (reportType === 'feedback') {
                            if (item.signalState) {
                                switch (item.signalState.code) {
                                    case SignalFeedbackEnum.Normal:
                                        symbolUrl = report_pin_green
                                        break
                                    case SignalFeedbackEnum.Abnormal:
                                        symbolUrl = report_pin_yellow
                                        break
                                    case SignalFeedbackEnum.None:
                                    default:
                                        symbolUrl = report_pin_red
                                        break
                                }
                            }
                        }

                        let symbol = new PictureMarkerSymbol({
                            width: 32,
                            height: 32,
                            yoffset: 16,
                            url: symbolUrl,
                        })
                        //symbol.url = symbolUrl
                        let gp = new Graphic({
                            geometry: itemPoint,
                            symbol: symbol,
                            attributes: item,
                        })

                        gp.attributes.reportType = reportType

                        this._graphicReportDataLayer.add(gp)
                    }
                }
            })

            const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)

            if (!isMobileDevice && multiPoint.extent && this._view && !this._view.destroyed && this._view.ready) {
                this._view.goTo(multiPoint.extent.expand(1.5))
            }
        }
    }

    _insertCustomMapLayer = async (mapUrl: string, mapType: MapCustomLayerType, callback: Function) => {
        let url = mapUrl
        const layerId = 'external-custom-' + this._currentCustomLayerIndex.toString()

        switch (mapType) {
            case 'layer':
                try {
                    fetch(url + '?f=json')
                        .then((response) => response.json())
                        .then((data) => {
                            //console.log('data',data);
                            if (data.singleFusedMapCache) {
                                let mapLayer = new TileLayer({
                                    id: layerId,
                                    url: url,
                                })
                                this._addExternalCustomLayerConfig(
                                    mapLayer,
                                    'tile',
                                    this._currentCustomLayerIndex,
                                    callback,
                                )
                            } else {
                                let mapLayer = new MapImageLayer({
                                    id: layerId,
                                    url: url,
                                })
                                this._addExternalCustomLayerConfig(
                                    mapLayer,
                                    'dynamic',
                                    this._currentCustomLayerIndex,
                                    callback,
                                )
                            }
                        })
                        .catch((err) => {
                            let result: MapCustomCreateResult = {
                                message: 'error',
                                error: err,
                            }
                            callback(result)
                        })
                } catch (ex) {
                    // console.log('asdasds', ex)
                }

                break
            case 'wms':
                let wmsLayer = new WMSLayer({
                    id: layerId,
                    url: url,
                })
                this._addExternalCustomLayerConfig(wmsLayer, mapType, this._currentCustomLayerIndex, callback)
                break
            case 'wmts':
                let wmtsLayer = new WMTSLayer({
                    id: layerId,
                    url: url,
                })

                this._addExternalCustomLayerConfig(wmtsLayer, mapType, this._currentCustomLayerIndex, callback)
                break
            default:
                break
        }
        this._currentCustomLayerIndex++
    }

    _addExternalCustomLayerConfig = async (
        newLayer: MapExternalLayer,
        mapType: MapCustomLayerType,
        index: number,
        callback?: Function,
    ) => {
        let reOrderIndex = this.internalCustomMapLayers.length + this.externalCustomMapLayers.length
        this._map.add(newLayer)
        this._map.reorder(newLayer, reOrderIndex)

        newLayer.on('layerview-create', () => {
            let newCustomItem = this._createCustomMapItem(newLayer, mapType, index)
            this.externalCustomMapLayers.push(newCustomItem)

            let result: MapCustomCreateResult = {
                item: newCustomItem,
                message: 'success',
                error: null,
            }

            callback?.(result)
        })

        newLayer.on('layerview-create-error', (evt) => {
            let result: MapCustomCreateResult = {
                message: 'error',
                error: evt.error,
            }
            callback?.(result)
        })
    }

    _createCustomMapItem = (newLayer: MapExternalLayer, mapType: MapCustomLayerType, index: number) => {
        let newCustomItem: MapCustomLayer = {
            id: newLayer.id,
            name: newLayer.title ?? 'Layer',
            itemIndex: index,
            url: newLayer.url ?? '',
            visible: newLayer.visible,
            type: mapType,
            opacity: 100,
        }

        if (mapType !== 'wmts' && mapType !== 'tile') {
            const subLayers = (newLayer as MapImageLayer).sublayers
            if (subLayers) {
                newCustomItem.subLayers = []
                subLayers.forEach((item: __esri.Sublayer) => {
                    newCustomItem.subLayers?.push({
                        id: item.id,
                        name: item.title ?? '',
                        visible: item.visible,
                    })
                })
            }
        }

        return newCustomItem
    }

    _removeCustomMapLayer = async (customLayerItem: MapCustomLayer) => {
        let findLayer = this._map.findLayerById(customLayerItem.id)
        if (findLayer) {
            this._map.remove(findLayer)
        }
        this.externalCustomMapLayers = this.externalCustomMapLayers.filter((item) => {
            return item.id !== customLayerItem.id
        })
    }

    _setVisibleCustomMapLayer = async (customLayerItem: MapCustomLayer, visible: boolean) => {
        let findLayer = this._map.findLayerById(customLayerItem.id)
        if (findLayer) {
            findLayer.visible = visible
        }
        customLayerItem.visible = visible
        this.externalCustomMapLayers = this.externalCustomMapLayers.map((item) =>
            item.id === customLayerItem.id ? customLayerItem : item,
        )
    }

    _setVisibleCustomMapSubLayer = async (customLayerItem: MapCustomLayer, subLayerId: number, visible: boolean) => {
        let findLayer: any = this._map.findLayerById(customLayerItem.id)

        const findSubLayer = findLayer.sublayers.find((item: __esri.Sublayer) => {
            return item.id === subLayerId
        })
        findSubLayer.visible = visible

        if (customLayerItem.subLayers) {
            let findSubLayer2 = customLayerItem.subLayers.find((subLayer) => subLayer.id === subLayerId)
            if (findSubLayer2) {
                findSubLayer2.visible = visible
                customLayerItem.subLayers = customLayerItem.subLayers.map((subLayer) =>
                    subLayer.id === subLayerId ? findSubLayer2 : subLayer,
                ) as MapCustomSubLayer[]
            }

            this.externalCustomMapLayers = this.externalCustomMapLayers.map((item) =>
                item.id === customLayerItem.id ? customLayerItem : item,
            )
        }
        //findLayer.visible = visible
        //customLayerItem.visible = visible
        //this.externalCustomMapLayers = this.externalCustomMapLayers.map(item => item.id === customLayerItem.id ? customLayerItem : item)
    }

    _setOpacityCustomMapLayer = async (customLayerItem: MapCustomLayer, opacity: number) => {
        let findLayer = this._map.findLayerById(customLayerItem.id)
        if (findLayer) {
            findLayer.opacity = opacity / 100
        }
        customLayerItem.opacity = opacity
        this.externalCustomMapLayers = this.externalCustomMapLayers.map((item) =>
            item.id === customLayerItem.id ? customLayerItem : item,
        )
    }

    _zoomLayerDefaultExtent = (layerId: string) => {
        let findLayer = this._map.findLayerById(layerId)
        if (findLayer) {
            let fullExtent = findLayer.fullExtent
            if (fullExtent) {
                if (fullExtent.spatialReference.wkid !== this._view.spatialReference.wkid) {
                    projection.load().then(() => {
                        let outSpatialReference = new SpatialReference({
                            wkid: this._view.spatialReference.wkid,
                        })
                        if (fullExtent) {
                            fullExtent = projection.project(fullExtent, outSpatialReference) as __esri.Extent
                        }
                        this._view.goTo(fullExtent)
                    })
                } else {
                    //console.log(findLayer.fullExtent.spatialReference.wkid)
                    this._view.goTo(fullExtent)
                }
            }
        }
        //console.log('findLayer.fullExtent',findLayer.fullExtent);
    }

    _setViewRotation = (rotation: number) => {
        this._view.rotation = rotation
        this.mapRotation = rotation
        this._reCalculateFlashlightAngle()
    }

    _reCalculateFlashlightAngle = () => {
        if (this._grpFlashlight) {
            //console.log('this._currentFlashLightAzimuth',this._currentFlashLightAzimuth );
            //const angle = this._currentFlashLightAzimuth //- this.mapRotation
            //console.log(this._currentFlashLightAzimuth - this.mapRotation);
            // const angle = this._currentFlashLightAzimuth > this.mapRotation ? 0 : 180
            // console.log('angle',angle);
            // const aaa = lang.clone(this._flashlightSymbol)
            // if (angle === 0){
            //     aaa.angle = this._currentFlashLightAzimuth - this.mapRotation
            //     this._grpFlashlight.symbol = aaa
            // }
            // else {
            //     //this._graphicReceptorLayer.remove(this._grpFlashlight)
            //     //this._flashlightSymbol.angle = 270
            //     this._grpFlashlight.symbol = this._identifyStationSymbol
            // }
            // console.log(this._currentFlashLightAzimuth - this.mapRotation);
            // let angle = 0
            // if (this._currentFlashLightAzimuth - this.mapRotation > 200){
            //     angle = 180
            // }
            // else {
            //     angle = 0
            // }
            // //this._flashlightSymbol.angle = 180
            // this._flashlightSymbol.angle = angle
            // this._grpFlashlight.symbol = this._flashlightSymbol
            // console.log('angle',angle);
            // this._flashlightSymbol.angle = angle
            // const { geometry } = this._grpFlashlight
            // this._graphicReceptorLayer.remove(this._grpFlashlight)
            // this._grpFlashlight = new Graphic({
            //     geometry: geometry,
            //     symbol: this._flashlightSymbol
            // })
            // this._graphicReceptorLayer.add(this._grpFlashlight)
            //this._grpFlashlight.set('symbol', this._flashlightSymbol)
        }
    }
}

const mapStoreContext = createContext(new MapStore())
const useMapStore = () => useContext(mapStoreContext)

export default useMapStore
